import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { slug } from "@/data/nav";
import { comingSoon } from "@/lib/site";

const ItemBody = ({ it, i }) => (
  <>
    <span className="font-mono text-[11px] text-violet-300/80">{String(i + 1).padStart(2, "0")}</span>
    <span className="flex-1">
      <span className="flex items-center gap-2 font-display text-[17px] font-medium text-white">
        {it.label}
        {it.soon && <span className="rounded-full border border-white/15 px-2 py-0.5 font-mono text-[10px] uppercase tracking-wider text-slate-400">Soon</span>}
      </span>
      <span className="mt-1 block text-[13px] leading-snug text-slate-400">{it.desc}</span>
    </span>
    <ArrowUpRight className="mt-1 h-4 w-4 text-slate-500 transition-all duration-300 group-hover:rotate-45 group-hover:text-violet-300" />
  </>
);

export const MegaPanel = ({ group }) => (
  <div className="border-t border-white/10 bg-[#0B0716]/95 backdrop-blur-2xl" data-testid={`mega-panel-${group.id}`}>
    <motion.div key={group.id} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.4 }}
      className="wrap grid grid-cols-12 gap-10 py-10">
      <div className="col-span-4 border-r border-white/10 pr-10">
        <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-violet-300">{group.label}</p>
        <p className="mt-4 font-display text-3xl font-medium leading-tight text-white">{group.intro}</p>
      </div>
      <div className="col-span-8 grid grid-cols-2 gap-x-6 gap-y-1">
        {group.items.map((it, i) => {
          const cls = "group flex items-start gap-4 rounded-2xl p-4 text-left transition-colors duration-300 hover:bg-white/[0.05]";
          const tid = `mega-item-${slug(it.label)}`;
          return it.to ? (
            <Link key={it.label} to={it.to} data-testid={tid} className={cls}><ItemBody it={it} i={i} /></Link>
          ) : (
            <button key={it.label} type="button" data-testid={tid} className={cls} onClick={() => comingSoon(it.label)}><ItemBody it={it} i={i} /></button>
          );
        })}
      </div>
    </motion.div>
  </div>
);
